<template>
    <railway-add-form></railway-add-form>
</template>


<script>

    import RailwayAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            RailwayAddForm,
        },

    }
</script>

